/**
 * Generated from LocationBackgroundLayout.fla
 */
export function LocationBackgroundLayout(this: ILocationBackgroundLayout) {
	const main = this.main;
	LocationBackgroundLayout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function LocationBackgroundLayout_main(this: ILocationBackgroundLayout_main) {
	const background = this.background;
	LocationBackgroundLayout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	if (background.onLayout) background.onLayout();
	return this;
}
function LocationBackgroundLayout_background(this: ILocationBackgroundLayout_background) {
	const backgroundSprite = this.backgroundSprite;
	LocationBackgroundLayout_backgroundSprite.call(this.backgroundSprite);
	backgroundSprite.x = 0;
	backgroundSprite.y = 0;
	backgroundSprite.width = 3328.00;
	backgroundSprite.height = 1536.00;
	if (backgroundSprite.onLayout) backgroundSprite.onLayout();
	const backgroundLarge = this.backgroundLarge;
	LocationBackgroundLayout_backgroundSprite.call(this.backgroundLarge);
	backgroundLarge.x = 0;
	backgroundLarge.y = 200;
	backgroundLarge.width = 4392.83;
	backgroundLarge.height = 2027.46;
	if (backgroundLarge.onLayout) backgroundLarge.onLayout();
	return this;
}
function LocationBackgroundLayout_backgroundSprite(this: ILocationBackgroundLayout_backgroundSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("background-beijing.png", 0.500, 0.500);
	return this;
}
interface ILocationBackgroundLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ILocationBackgroundLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ILocationBackgroundLayoutSprite extends ILocationBackgroundLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ILocationBackgroundLayoutText extends ILocationBackgroundLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ILocationBackgroundLayoutPolygon extends Array<number> {
}
interface ILocationBackgroundLayout {
	readonly main: ILocationBackgroundLayout_main;
}
interface ILocationBackgroundLayout_main extends ILocationBackgroundLayoutContainer {
	readonly background: ILocationBackgroundLayout_background;
}
interface ILocationBackgroundLayout_background extends ILocationBackgroundLayoutContainer {
	readonly backgroundSprite: ILocationBackgroundLayout_backgroundSprite;
	readonly backgroundLarge: ILocationBackgroundLayout_backgroundSprite;
}
interface ILocationBackgroundLayout_backgroundSprite extends ILocationBackgroundLayoutSprite {
}
